import { lazy } from "react";

// Lazy-loaded components - SECTION HOME
export const Navbar2 = lazy(() => import("../interface/navbar/Navbar2"));
export const ImageSlider = lazy(() => import("../interface/carousel_image_slider/ImageSlider"));
export const Portofolio = lazy(() => import("../pages/components/portofolio/Portofolio"));
export const FloatingWhatsApp = lazy(() => import("../interface/floating_whatsapp/FloatingWhatsApp"));
export const Footer = lazy(() => import("../pages/Footer"));
export const OurService = lazy(() => import("../pages/components/rekanata/pages/OurService"));